import axios from 'axios'
import { Message } from 'element-ui'
import store from '@/store'

const service = axios.create({
  baseURL: '/api',
  timeout: 15000
})

service.interceptors.request.use(config => {
  const token = store.state.token
  if (token) {
    config.headers.Authorization = 'Bearer ' + token
  }
  return config
})

service.interceptors.response.use(
  res => {
    const data = res.data
    if (data.code === 200) return data
    Message.error(data.msg || 'Request failed')
    return Promise.reject(data)
  },
  err => {
    if (err.response && err.response.status === 401) {
      store.commit('CLEAR_AUTH')
      import('@/router').then(({ default: router, resetRouter }) => {
        resetRouter()
        router.push('/login')
      })
    }
    if (!err.config || !err.config.skipErrorHandler) {
      Message.error(err.message || 'Network error')
    }
    return Promise.reject(err)
  }
)

export default service
